import React, { useState } from "react";
import "./ShippingAddress.css";
import { Radio, Space } from "antd";
import TextArea from "antd/es/input/TextArea";

const PaymentMethod = ({ bookingBy, setBookingBy, comment, setComment }) => {
  const onChange = (e) => {
    setBookingBy(e.target.value);
  };

  return (
    <section className="ShipOrder my-4">
      <Radio.Group onChange={onChange} value={bookingBy}>
        <Space direction="vertical">
          <Radio
            value="payOnOrder"
            style={{ display: "flex", alignItems: "start" }}
          >
            <strong style={{ fontSize: "1.2rem" }}>Pay on order</strong>
            <p>Complete payment through offline methods.</p>
          </Radio>

          <Radio value="payNow">
            <strong style={{ fontSize: "1.2rem" }}>Pay Now</strong>
            <p>
              Complete payment using PayPal, with an additional charge of 3%.
            </p>
            <p>
              <strong>Note: </strong> Shipping address on payment receipt should
              match with KYC address
            </p>
          </Radio>
        </Space>
      </Radio.Group>
      <TextArea
        className="mt-4"
        placeholder="Any Comment"
        maxLength={500}
        showCount
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
    </section>
  );
};

export default PaymentMethod;
